// https://blog.csdn.net/gs981600308/article/details/88997292

import XLSX from "xlsx"
import FileSaver from "file-saver"

export default function (className,excelName) {


  var xlsxParam = { raw: true } // 导出的内容只做解析，不进行格式转换
  let fix = document.querySelector('.el-table__fixed');
  console.log(fix);
  
  let wb;
  if (fix) { //判断要导出的节点中是否有fixed的表格，如果有，转换excel时先将该dom移除，然后append回去
    wb = XLSX.utils.table_to_book(document.querySelector(className).removeChild(fix), xlsxParam);
    document.querySelector(className).appendChild(fix);
  } else {
    wb = XLSX.utils.table_to_book(document.querySelector(className), xlsxParam);
  }
  var wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' });

  FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), excelName + '.xlsx')
}